@if (!validSearch) {
  <h3>Search for possible matches</h3>
}
@if (validSearch) {
  <h3>Assign Guest Role</h3>
}

@if (spinner) {
  <div id="spinner-layover">
    <mat-spinner></mat-spinner>
  </div>
}

<br />
<form class="form">
  @if (!validSearch) {
    <div id="search-container">
      <app-guest-search [guest]="guestRole.guest"></app-guest-search>
      <br />
      <div class="action-container">
        <button (click)="findPossibleMatchesForPerson(guestRole.guest)" mat-raised-button color="primary">Find possible matches</button>
        <button mat-raised-button routerLink="/sponsor" class="cancel-button" color="warn">Cancel</button>
      </div>
    </div>
  }

  @if (validSearch) {
    <div class="guest-view">
      <mat-card appearance="outlined" class="guest-form">
        <app-guest-form [guest]="guestRole.guest" [isNewAccount]="!guestRole.guest.existingNotGuestAccount"></app-guest-form>
      </mat-card>
      <div class="role-info">
        <mat-card appearance="outlined" class="role-form">
          <app-role-form [guestRole]="guestRole" [roles]="roles"></app-role-form>
        </mat-card>
      </div>
    </div>

    <ng-container id="guest-container">
      <br />
      <div class="action-container">
        <button (click)="createGuestRole()" mat-raised-button color="primary">Submit</button>
        <button mat-raised-button routerLink="/sponsor" color="warn" class="cancel-button">Cancel</button>
      </div>
    </ng-container>
  }
</form>
<br />
